import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  // ===== 用户端路由 =====
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/Home.vue'),
    meta: { title: 'NEXA EXWORTH' }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/Dashboard.vue'),
    meta: { title: 'Dashboard' }
  },
  {
    path: '/tai',
    name: 'tai',
    component: () => import('@/views/Eco.vue'),
    meta: { title: '生态' }
  },
  {
    path: '/mynode',
    name: 'mynodes',
    component: () => import('@/views/NodeLists.vue'),
    meta: { title: 'Nodes' }
  },
  {
    path: '/prediction',
    name: 'prediction',
    component: () => import('@/views/Prediction.vue'),
    meta: { title: 'Prediction' }
  },
  {
    path: '/community',
    name: 'community',
    component: () => import('@/views/Community.vue'),
    meta: { title: 'Community' }
  },
  {
    path: '/swap',
    name: 'swap',
    component: () => import('@/views/Swap.vue'),
    meta: { title: 'Swap' }
  },

  // ===== 管理端路由（独立路径，不与用户端混用）=====
  {
    path: '/super/login',
    name: 'admin.login',
    component: () => import('@/views/admin/AdminLogin.vue'),
    meta: { title: '管理员登录', requiresAdminGuest: true }
  },
  {
    path: '/super',
    component: () => import('@/views/admin/AdminLayout.vue'),
    meta: { requiresAdmin: true },
    children: [
      {
        path: '',
        name: 'admin.dashboard',
        component: () => import('@/views/admin/AdminDashboard.vue'),
        meta: { title: '数据概览' }
      },
      {
        path: 'users',
        name: 'admin.users',
        component: () => import('@/views/admin/AdminUsers.vue'),
        meta: { title: '用户管理' }
      },
      {
        path: 'nodes',
        name: 'admin.nodes',
        component: () => import('@/views/admin/AdminNodes.vue'),
        meta: { title: '节点管理' }
      },
      {
        path: 'withdraw',
        name: 'admin.withdraw',
        component: () => import('@/views/admin/AdminWithdraw.vue'),
        meta: { title: '提现审核' }
      },
      // {
      //   path: 'subsidy',
      //   name: 'admin.subsidy',
      //   component: () => import('@/views/admin/AdminSubsidy.vue'),
      //   meta: { title: '社区补贴' }
      // },
      {
        path: 'pool',
        name: 'admin.pool',
        component: () => import('@/views/admin/AdminPool.vue'),
        meta: { title: '底池管理' },
        requiresSuperAdmin: true // ✅ 标记需要超级管理员权限
      },
      {
        path: 'operation',
        name: 'admin.operation',
        component: () => import('@/views/admin/AdminOperation.vue'),
        meta: { 
          title: '节点合约操作',
          requiresSuperAdmin: true   // ✅ 仅超级管理员可见
        }
      },
      {
        path: 'burn1',
        name: 'admin.burn1',
        component: () => import('@/views/admin/BurnManagement.vue'),
        meta: { 
          title: '分红燃烧操作',
          requiresSuperAdmin: true   // ✅ 仅超级管理员可见
        }
      },
      {
        path: 'burn',
        name: 'admin.burn',
        component: () => import('@/views/admin/AdminBurn.vue'),
        meta: { title: '燃烧管理' 
        }
      },
      // {
      //   path: 'config',
      //   name: 'admin.config',
      //   component: () => import('@/views/admin/AdminConfig.vue'),
      //   meta: { title: '系统配置' }
      // },
       {
        path: 'info',
        name: 'admin.info',
        component: () => import('@/views/admin/AdminInfo.vue'),
        meta: { title: '修改密码' }
      },
      {
        path: 'admins',
        name: 'admin.admins',
        component: () => import('@/views/admin/AdminAdmins.vue'),
        meta: { 
          title: '管理员管理',
          requiresSuperAdmin: true // ✅ 标记需要超级管理员权限
        }
      },
    ]
  },

  // 404 兜底 - 用户端路径回首页，admin路径回admin登录
  {
    path: '/:pathMatch(.*)*',
    redirect: (to) => {
      if (to.path.startsWith('/super')) return '/super/login'
      return '/'
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    return { top: 0 }
  }
})

router.beforeEach((to, from, next) => {
  // 设置页面标题
  const baseTitle = to.path.startsWith('/super') ? 'UK Platform Admin' : 'NEXA EXWORTH'
  document.title = to.meta.title ? `${to.meta.title} | ${baseTitle}` : baseTitle

  const adminToken = localStorage.getItem('admin_token')
  const adminRole = parseInt(localStorage.getItem('admin_role') || '0')

  // 需要管理员权限的页面
  if (to.meta.requiresAdmin) {
    if (!adminToken) {
      next({ path: '/super/login', replace: true })
      return
    }
    
    // ✅ 检查是否需要超级管理员权限
    if (to.meta.requiresSuperAdmin && adminRole !== 2) {
      alert('此功能仅超级管理员可用')
      next({ path: '/super', replace: true })
      return
    }
  }

  // 已登录管理员不能访问管理员登录页
  if (to.meta.requiresAdminGuest) {
    if (adminToken) {
      next({ path: '/super', replace: true })
      return
    }
  }

  next()
})


export default router